import React, { useState } from "react";
import { Carousel } from 'react-bootstrap';
import Room1 from '../../assets/Images/FW/1.jpg';
import Room2 from '../../assets/Images/FW/2.jpg';
import Room3 from '../../assets/Images/FW/3.jpg';
import Room4 from '../../assets/Images/FW/4.jpg';
import Room5 from '../../assets/Images/FW/5.jpg';
import Room6 from '../../assets/Images/FW/6.jpg';
import Room7 from '../../assets/Images/FW/7.jpg';
import Room8 from '../../assets/Images/FW/8.jpg';
import Room9 from '../../assets/Images/FW/9.jpg';
import Room10 from '../../assets/Images/FW/10.jpg';
import Room11 from '../../assets/Images/FW/11.jpg';
import Room12 from '../../assets/Images/FW/12.jpg';
import Room13 from '../../assets/Images/FW/13.jpg';
import Room14 from '../../assets/Images/FW/14.jpg';
import Room15 from '../../assets/Images/FW/15.jpg';
import Room16 from '../../assets/Images/FW/16.jpg';
import Room17 from '../../assets/Images/FW/17.jpg';
import Room18 from '../../assets/Images/FW/18.jpg';
import Room19 from '../../assets/Images/FW/19.jpg';
import Room20 from '../../assets/Images/FW/20.jpg';
import Room21 from '../../assets/Images/FW/21.jpg';
import Room22 from '../../assets/Images/FW/22.jpg';
import Room23 from '../../assets/Images/FW/23.jpg';
import Room24 from '../../assets/Images/FW/24.jpg';
import Room25 from '../../assets/Images/FW/25.jpg';
import Room26 from '../../assets/Images/FW/26.jpg';
import Room27 from '../../assets/Images/FW/27.jpg';
import Room28 from '../../assets/Images/FW/28.jpg';
import Room29 from '../../assets/Images/FW/29.jpg';

import "./ImageSlider.css";

const ImageSlider = () => {
  const rooms = [
    Room1, Room2, Room3, Room4, Room5, Room6, Room7, Room8,
    Room9, Room10, Room11, Room12, Room13, Room14, Room15,
    Room16, Room17, Room18, Room19, Room20, Room21, Room22, Room23, Room24, Room25, Room26, Room27, Room28, Room29,
  ];

  const designs = [
    Room1, Room2, Room3, Room4, Room5, Room6, Room7, Room8,
    Room9, Room10, Room11, Room12, Room13, Room14, Room15,
    Room16, Room17, Room18, Room19, Room20, Room21, Room22, Room23, Room24, Room25, Room26, Room27, Room28, Room29,
  ];

  const [isPaused, setIsPaused] = useState(false);

  return (
    <>
      <div className="slider-container">
        <Carousel className="slider-carousel" controls={false} indicators={false} interval={4000}>
          {rooms.map((room, index) => (
            <Carousel.Item key={index}>
              <img
                className="d-block w-100 slider-image"
                src={room}
                alt={`Room ${index + 1}`}
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

    <div
      className="logo-carousel-container"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div
        className="logo-carousel"
        style={{
          animationPlayState: isPaused ? "paused" : "running",
        }}
      >
        {designs.map((logo, index) => (
          <div className="logo-item" key={index}>
            <img src={logo} alt={`Logo ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default ImageSlider;
